export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const STORE = {
  name: "Knoble Rides Enterprises",
  shortName: "Knoble Rides",
  motto: "Bikes for All Ages",
  phoneDisplay: "0806 164 1299",
  phoneRaw: "08061641299",
  phoneTel: "tel:08061641299",
  whatsappNumber: "2348061641299",
  instagram: "@knoble_bicycles",
  instagramUrl: "https://instagram.com/knoble_bicycles",
  address: "MRS Filling Station, Mangoro, along Abeokuta Express Road, Lagos, Nigeria",
  addressShort: "Mangoro, Abeokuta Express Road, Lagos",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_knoble-rides/artifacts/ksb1f7om_Red_and_Black_Biking_Dynamic_Frames_Sports_Logo-removebg-preview.png",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent("MRS Filling Station, Mangoro, Abeokuta Express Road, Lagos, Nigeria"),
  mapEmbedUrl:
    "https://maps.google.com/maps?q=" +
    encodeURIComponent("MRS Filling Station Mangoro Abeokuta Express Road Lagos") +
    "&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const OFFER = "Includes Free Helmet & Bike Pump";

export const CATEGORIES = [
  {
    id: "electric-bikes",
    name: "Electric Bikes",
    tagline: "Power-assisted, effortless commuting",
    image: "https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?auto=format&fit=crop&q=85&w=700",
  },
  {
    id: "mountain-bikes",
    name: "Mountain Bikes",
    tagline: "Rugged suspension & high-grip traction",
    image: "https://images.unsplash.com/photo-1606087492572-424ebe0f2f61?auto=format&fit=crop&q=85&w=700",
  },
  {
    id: "road-bikes",
    name: "Road Bikes",
    tagline: "Lightweight aerodynamic velocity",
    image: "https://images.unsplash.com/photo-1496147433903-1e62fdb6f4be?auto=format&fit=crop&q=85&w=700",
  },
  {
    id: "bmx-bikes",
    name: "BMX Bikes",
    tagline: "Stunt, street & skatepark durability",
    image: "https://images.pexels.com/photos/5657429/pexels-photo-5657429.jpeg?auto=compress&cs=tinysrgb&w=700",
  },
  {
    id: "kids-bikes",
    name: "Kids Bikes",
    tagline: "Safe, vibrant & sturdy for young riders",
    image: "https://images.unsplash.com/photo-1571333472132-fb0e0f24d54a?auto=format&fit=crop&q=85&w=700",
  },
  {
    id: "accessories",
    name: "Bike Accessories",
    tagline: "Helmets, pumps, lights, locks & gear",
    image: "https://images.pexels.com/photos/8926730/pexels-photo-8926730.jpeg?auto=compress&cs=tinysrgb&w=700",
  },
];

export const CATEGORY_LABELS = CATEGORIES.reduce((acc, c) => {
  acc[c.id] = c.name;
  return acc;
}, { accessories: "Bike Accessories" });

export const REAL_PHOTOS = [
  "https://customer-assets-eiarnc6j.emergentagent.net/job_da009b02-34d0-476b-a30f-046773aa2bfa/artifacts/msxdqxf7_phto%201.webp",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_da009b02-34d0-476b-a30f-046773aa2bfa/artifacts/qsdjumfq_WhatsApp%20Image%202026-09-05%20at%2010.02.48%20PM.jpeg",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_da009b02-34d0-476b-a30f-046773aa2bfa/artifacts/6m1k4ts0_WhatsApp%20Image%202026-09-05%20at%2010.02.45%20PM.jpeg",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_da009b02-34d0-476b-a30f-046773aa2bfa/artifacts/sazsf4rt_WhatsApp%20Image%202026-09-05%20at%2010.02.45%20PM%20%281%29.jpeg",
];

export const HERO_SLIDES = [
  {
    image: REAL_PHOTOS[0],
    title: "Unleash Pure Freedom On Two Wheels",
    subtitle: "Quality mountain, road, electric, BMX & kids bicycles — for every rider.",
  },
  {
    image: REAL_PHOTOS[3],
    title: "Bikes Built For Nigeria's Roads & Trails",
    subtitle: "Every purchase includes a FREE helmet and high-grade bike pump.",
  },
  {
    image: REAL_PHOTOS[2],
    title: "Trusted Bike Experts In Mangoro, Lagos",
    subtitle: "Visit us or enquire on WhatsApp — fast, friendly response guaranteed.",
  },
];

export const TESTIMONIALS = [
  { name: "Tunde A.", location: "Ikeja, Lagos", quote: "Bought a mountain bike here and the free helmet & pump were a lovely surprise. Genuine quality and honest advice." },
  { name: "Chidinma O.", location: "Ojota", quote: "Got a kids bike for my son. The team helped me pick the right size and responded on WhatsApp in minutes." },
  { name: "Emeka N.", location: "Berger", quote: "Great range of BMX bikes. Prices are fair and the bikes are solid. Highly recommend Knoble Rides." },
  { name: "Aisha B.", location: "Agege", quote: "Smooth experience from enquiry to pickup. The electric bike I bought is perfect for my daily commute." },
  { name: "David K.", location: "Mangoro", quote: "Best bicycle shop around. Friendly people, strong bikes for all ages, and they stand by what they sell." },
  { name: "Funke S.", location: "Ketu", quote: "I love that everything is on WhatsApp — no stress. My daughter's bike came with a helmet and pump too!" },
];

export const waLink = (message) =>
  `https://wa.me/${STORE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};
